// 偵測動態 chunk 載入/解析失敗（CDN 回傳損壞但 200 的 JS 被 Workbox 快取後永久重現，
// 對應 CLIENT-PWA-SSR-BD：runtime-13 非同步元件載入器丟出 SyntaxError），
// 清掉所有快取 + 反註冊 SW + 重載一次。sessionStorage guard 確保每個 session 至多重載一次，
// 避免網路持續損壞時的無限重載循環；達上限後讓錯誤正常上報以利後續 triage。
import { usePwaUpdate } from '@/composables/core/usePwaUpdate'

const GUARD_KEY = 'chunk-recovery-reloaded'
const CHUNK_ERROR_RE =
  /Invalid or unexpected token|Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module/i

export default defineNuxtPlugin((nuxtApp) => {
  const isChunkError = (error) => error instanceof Error && CHUNK_ERROR_RE.test(error.message || '')

  const recover = async (reason) => {
    if (sessionStorage.getItem(GUARD_KEY)) return
    sessionStorage.setItem(GUARD_KEY, '1')
    console.error('[chunk-recovery] purge caches + reload:', reason)
    try {
      const { forceReload } = usePwaUpdate()
      await forceReload()
    } catch (error) {
      console.error('[chunk-recovery] forceReload failed, hard reloading:', error)
      window.location.reload()
    }
  }

  // Vue 非同步元件載入器（runtime-13）拋出的解析錯誤 → BD 走這條
  nuxtApp.hook('vue:error', (error) => {
    if (isChunkError(error)) recover(`vue:error: ${error?.message}`)
  })

  // Vite preload 失敗（多為 fetch 失敗），縱深補強
  nuxtApp.hook('app:chunkError', ({ error }) => {
    if (isChunkError(error)) recover(`app:chunkError: ${error?.message}`)
  })
})
